<template>
  <div>
    <div class="tab-bar">
      <slot name="tabs" :context="context" :tabClicked="tabClicked"></slot>
    </div>
    <slot name="content" :context="context"></slot>
  </div>
</template>
<script>
export default {
  props: {
    defaultTab: {
      type: String,
      required: false,
      default: "",
    },
  },
  data: function() {
    return {
      context: {
        activeTabId: this.defaultTab,
      },
    };
  },
  watch: {
    defaultTab: function(newValue) {
      this.context.activeTabId = newValue;
    },
  },
  methods: {
    tabClicked: function(id) {
      this.context.activeTabId = id;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/_css/variables";

.tab-bar {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  top: 1px;
  height: 30px;
  background-color: $gray-300;
  border-bottom: 1px solid $gray-500;
  border-radius: $border-radius $border-radius 0px 0px;
}
</style>
